
import verification from "@/components/verificationCode/verification.vue";
import { canAuthorEditContent } from "@/utils/contentEdit";
export default {
  name: "index",
  components: { verification },
  head() {
    // 优化seo：动态设置title，keywords 和 description
    return {
      script: [
        { src: "https://gosspublic.alicdn.com/aliyun-oss-sdk-6.16.0.min.js" },
        // { src: "https://cdn.quilljs.com/1.3.4/quill.js" },
        // { src: "https://cdn.jsdelivr.net/npm/vue-quill-editor@3.0.6/dist/vue-quill-editor.js" }
      ], //cdn方式引入ali-oss
    };
  },
  middleware: "userAuth", //中间件页面登录鉴权
  data() {
    return {
      postTitle: "", //帖子标题
      content: "", //富文本内容
      productValue: "", //当前选中产品
      activityList: [], //活动列表
      tag_list: [], //标签列表
      voteGoods: [], //产品列表
      submitLoading: false, //上传ing
      rand_code: "", //上传随机码
      loading: false,
      schedule: "", //上传进度
      editorOption: {
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
              ["blockquote", "code-block"], //引用，代码块
              [{ header: 1 }, { header: 2 }], // 几级标题
              [{ list: "ordered" }, { list: "bullet" }], // 有序列表，无序列表
              [{ script: "sub" }, { script: "super" }], // 下角标，上角标
              [{ indent: "-1" }, { indent: "+1" }], // 缩进
              [{ direction: "rtl" }], // 文字输入方向
              [{ size: ["small", false, "large", "huge"] }], // 字体大小
              [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
              [{ color: [] }, { background: [] }], // 颜色选择
              [
                {
                  font: [
                    "SimSun",
                    "SimHei",
                    "Microsoft-YaHei",
                    "KaiTi",
                    "FangSong",
                    "Arial",
                  ],
                },
              ], // 字体
              [{ align: [] }], // 居中
              ["clean"], // 清除样式,
              ["link", "image", "video"], // 上传图片、上传视频
              ["vote"],
              ["at"],
            ],
            handlers: {
              image: (value) => {
                if (value) {
                  // 调用element的图片上传组件
                  document.querySelector(".avatar-uploader input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
              video: (value) => {
                if (value) {
                  // 调用element的视频上传组件
                  document.querySelector(".uploaderVideo input").click();
                } else {
                  this.quill.format("video", false);
                }
              },
              vote: () => {
                //打开投票模态框
                this.voteDialog = true;
              },
              at: () => {
                //打开@模态框
                this.atDialogVisible = true;
              },
              link: (value) => {
                this.handleQuillLink(value);
              },
            },
          },
        },
        placeholder: "Enter content",
      }, //编辑器配置项
      imageUrl: "",
      serverResultUrl: "",
      editId: "", // 有值表示编辑已有帖子，提交时带回原 id
      lockedActivityId: "", // 编辑时回传的活动 id，来自 edit_info.activityId
      editImages: [], // 预填图片地址，提交 imagePath 时沿用
      editThumb: "", // 预填封面，更换封面后替换 imagePath 里的对应地址
      editAppointUid: "", // 预填的 @ 人，用户未重新 @ 时原样提交
      editContentVideo: "", // 预填内容视频
      editVideoTime: "", // 预填视频时长
      editThumbVideo: "", // 预填视频封面
      editType: 1, // 预填的帖子类型，1 图片 2 视频
      fileList: [], //文件列表
      allImagePath: [], //所有图片的地址
      ossConfig: {},
      video: "",
      voteDialog: false, //投票模态框
      voteDialogWidth: "25%", //投票模态框宽度
      postsTitle: "", //投票名称
      methodType: "1", //1单选2多选
      endTime: "", //结束时间
      voteOptions: [
        { name_type: "", vote_img: "" },
        { name_type: "", vote_img: "" },
      ], //投票选项
      voteContent: false, //投票内容
      atDialogVisible: false, //@弹窗
      userList: [], //@用户列表
      appoint_uid: [], //@的用户
      voteImgIndex: "", //投票图片当前索引
      captchaCode: "",
      pendingLinkRange: null, // 添加链接前的选区
      linkDialog: false,
      linkUrl: "",
      linkSnapshot: null, // 加链接前的文档，写入失败时恢复
      applyingLink: false, // 正在写入链接，避免正文被同步成空
      isEditorClient: false, // 编辑器含 Quill/Upload/Dialog，整页客户端挂载避免 hydration 不一致
      fieldErrors: {
        title: false,
        content: false,
        cover: false,
        tag: false,
      },
    };
  },
  async asyncData({ $global, params }) {
    const res = await $global.releaseConfigure();
    if (res.code !== 200 || !res.data) {
      return {
        activityList: [],
        tag_list: [],
        voteGoods: [],
        rand_code: "",
      };
    }
    res.data.tag_list.forEach((item) => {
      item.active = false;
      item.bgColor = "";
    });
    return {
      activityList: res.data.activityList,
      tag_list: res.data.tag_list,
      voteGoods: res.data.voteGoods,
      rand_code: res.data.rand_code,
    };
  },
  created() {
    // this.getReleaseConfigure()
    // this.aliOssConfig()
  },
  beforeMount() {
    // 编辑器创建前注册，否则 Quill 会丢掉 data-uid，并给站内链接加上 target
    this.registerAtUserLink();
  },
  mounted() {
    this.isEditorClient = true;
    this.$nextTick(() => {
      this.dialogSize();
      this.atlist();
      this.$nextTick(() => {
        this.loadEditSource();
      });
    });
  },
  methods: {
    initVote() {
      //初始化投票点击
      if (document.querySelector(".ql-vote")) {
        const editorButton = document.querySelector(".ql-vote");
        if (editorButton !== undefined) {
          editorButton.innerHTML =
            '<svg t="1673401667915" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2715" width="18" height="18"><path d="M616.4 893.1H399.9c-10.9 0-19.7-8.3-19.7-18.5v-758c0-10.2 8.8-18.5 19.7-18.5h216.5c10.9 0 19.7 8.3 19.7 18.5v757.9c0 10.3-8.8 18.6-19.7 18.6z m-196.8-37h177.1v-721H419.6v721z" p-id="2716"></path><path d="M832.8 893H616.4c-10.9 0-19.7-8.3-19.7-18.5v-573c0-10.2 8.8-18.5 19.7-18.5h216.5c10.9 0 19.7 8.3 19.7 18.5v573c-0.1 10.2-8.9 18.5-19.8 18.5z m-196.7-37h177.1V320H636.1v536zM399.9 893.1H183.5c-10.9 0-19.7-8.3-19.7-18.5V430.9c0-10.2 8.8-18.5 19.7-18.5H400c10.9 0 19.7 8.3 19.7 18.5v443.7c-0.1 10.2-8.9 18.5-19.8 18.5z m-196.8-37h177.1V449.4H203.1v406.7z" p-id="2717"></path><path d="M913.1 893.1H103.9c-10.2 0-18.5-8.3-18.5-18.5s8.3-18.5 18.5-18.5h809.2c10.2 0 18.5 8.3 18.5 18.5s-8.3 18.5-18.5 18.5z" p-id="2718"></path></svg>';
        }
      }
    },
    initAt() {
      //初始化@
      if (document.querySelector(".ql-at")) {
        const editorAt = document.querySelector(".ql-at");
        if (editorAt !== undefined) {
          editorAt.innerHTML =
            '<svg t="1675742116928" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1985" width="24" height="24"><path d="M685.7 829.5c-60.4 32.3-128.5 47.5-196.9 44.1-14.2-0.8-26.2 10.2-26.9 24.3-0.7 14.1 10.2 26.2 24.3 26.9 7.2 0.4 14.4 0.5 21.6 0.5 70.4 0 139.8-17.3 202.1-50.6 12.5-6.7 17.2-22.2 10.5-34.7-6.7-12.5-22.2-17.2-34.7-10.5zM764 172.9C624.1 80.4 441.9 78 299.6 166.7 176.2 243.7 101 376.4 98.3 521.8c-2.6 145.8 75 280 202.7 350.3 11.2 6.2 22.8 11.9 34.4 17 3.4 1.5 6.9 2.2 10.3 2.2 9.9 0 19.3-5.7 23.5-15.3 5.7-13-0.2-28.1-13.2-33.8-10.2-4.5-20.4-9.5-30.2-14.9-111-61.1-178.5-177.8-176.2-304.5 2.3-128 68.6-244.8 177.1-312.5 125.3-78.1 285.8-76 409 5.4C843 286.5 895.2 418.2 865.6 543.4c-14.1 59.6-59.5 107-118.5 123.5-28.6 8-58.3 0.4-79.5-20.4-21.2-20.8-29.4-50.4-21.9-79.1l61.1-234.8c3.6-13.7-4.7-27.7-18.3-31.3-13.7-3.5-27.7 4.6-31.3 18.3L639 389.9c-18-38.8-47.7-69.3-87-84.5-93.2-36.1-205.2 27.8-249.5 142.4-44.3 114.6-4.5 237.1 88.7 273.2 17.7 6.8 36 10.1 54.4 10.1 58.2 0 117.2-32.5 158.6-86.9 6.7 14.2 15.9 27.4 27.6 38.9 34.5 33.8 82.8 46.2 129.3 33.1 76.9-21.6 136.1-83.3 154.5-161.1C950 409.2 889.1 255.5 764 172.9zM409.7 673.1c-66.9-25.9-93.5-118.7-59.4-206.9 28.1-72.6 88.7-119.8 146.6-119.8 12.4 0 24.8 2.2 36.6 6.8 66.9 25.9 93.5 118.7 59.4 206.9-34.2 88.2-116.4 138.9-183.2 113z" p-id="1986"></path></svg>';
        }
      }
    },
    /** 编辑已有帖子时，用 /posts/edit_info 预填标题、正文、封面、图片和标签 */
    async loadEditSource() {
      const id = Number(this.$route.query.id);
      if (!id) {
        return;
      }
      this.editId = String(id);
      const res = await this.$global.postsEditInfo({ id });
      if (res.code !== 200 || !res.data) {
        this.$message.error((res && res.msg) || this.$t("page.UNKNOWN_ERROR"));
        this.$router.replace({ path: `/discussion/${id}` });
        return;
      }
      const data = res.data;
      if (!canAuthorEditContent(data.status)) {
        this.$message.error(this.$t("page.UNKNOWN_ERROR"));
        this.$router.replace({ path: `/discussion/${id}` });
        return;
      }
      this.editType = data.type === 2 ? 2 : 1;
      this.postTitle = data.title || "";
      this.content = this.normalizeAtMentions(data.content || "");
      this.$nextTick(() => {
        const quill = this.$refs.myQuillEditor && this.$refs.myQuillEditor.quill;
        if (quill) {
          quill.clipboard.dangerouslyPasteHTML(this.content);
        }
      });
      this.applySelectedTags(data.tags);
      if (data.goods_id) {
        this.productValue = data.goods_id;
      }
      this.editImages = Array.isArray(data.images) ? data.images.filter(Boolean) : [];
      this.editThumb = data.thumb || "";
      this.editAppointUid = data.appoint_uid || "";
      this.editContentVideo = data.content_video || "";
      this.editVideoTime = data.video_time || "";
      this.editThumbVideo = data.thumb_video || "";
      this.lockedActivityId = data.activityId ? data.activityId : "";
      this.applyEditVote(data);
      if (data.thumb) {
        this.serverResultUrl = data.thumb;
        this.imageUrl = data.thumb;
        this.fileList = [{ name: "cover", url: data.thumb }];
      }
      if (data.content_video) {
        this.video = {
          realityUrl: data.content_video,
          virtualUrl: data.content_video,
        };
      }
    },
    /**
     * 用 edit_info 的 posts_vote 回填投票，便于继续修改。
     * 选项只认 name_type、vote_img、vote_id；结束时间是秒，日期控件用毫秒。
     */
    applyEditVote(data) {
      const options = Array.isArray(data.posts_vote) ? data.posts_vote : [];
      if (!options.length) {
        return;
      }
      this.postsTitle = data.posts_title || "";
      this.methodType = String(data.method_type || 1);
      const endSeconds = Number(data.end_time);
      this.endTime = endSeconds > 0 ? endSeconds * 1000 : "";
      this.voteOptions = options.map((item) => {
        const option = {
          name_type: item.name_type || "",
          vote_img: item.vote_img || "",
        };
        if (item.vote_id != null && item.vote_id !== "") {
          option.vote_id = item.vote_id;
        }
        return option;
      });
      this.voteContent = true;
    },
    /** 按 edit_info.tags 的标签名勾选发布页预设标签 */
    applySelectedTags(tagList) {
      const names = Array.isArray(tagList) ? tagList : [];
      (this.tag_list || []).forEach((item) => {
        this.$set(item, "active", names.includes(item.tag_name));
      });
    },
    /** 编辑提交的图片地址：未换封面时用 images，换了封面则替换原 thumb */
    buildEditImagePath() {
      const cover = this.serverResultUrl || "";
      const images = Array.isArray(this.editImages) ? this.editImages.filter(Boolean) : [];
      if (!images.length) {
        return cover;
      }
      if (!this.editThumb || cover === this.editThumb) {
        return images.join();
      }
      const next = images.map((url) => (url === this.editThumb ? cover : url));
      if (cover && !next.includes(cover)) {
        next.unshift(cover);
      }
      return next.filter(Boolean).join();
    },
    /** 移除封面后清空编辑回填的封面地址 */
    handleDiscussionCoverRemove() {
      this.serverResultUrl = "";
      this.imageUrl = "";
      this.fileList = [];
    },
    async atlist() {
      let res = await this.$global.userNotice();
      res.code == 200 ? (this.userList = res.data) : "";
    },
    clearVote() {
      //删除投票
      this.postsTitle = this.endTime = "";
      this.methodType = "1";
      this.voteOptions = [
        { name_type: "", vote_img: "" },
        { name_type: "", vote_img: "" },
      ];
      this.voteContent = false;
    },
    onEditorBlur(editor) {
      // console.log("editor blur!", editor);
    },
    onEditorFocus(editor) {
      // console.log("editor focus!", editor);
    },
    onEditorReady(editor) {
      // console.log("editor ready!", editor);
      this.$nextTick(() => {
        const quill = this.$refs.myQuillEditor?.__quill;
        if (quill) {
          this.bindQuillEditorClickArea(quill);
          this.guardQuillContent(quill);
        }
        this.initVote();
        this.initAt();
      });
    },
    /** 点击工具栏下方空白容器时聚焦编辑器（兜底） */
    bindQuillEditorClickArea(quill) {
      const editorEl = quill.root;
      const container = editorEl?.parentElement;
      if (!container || container.dataset.quillClickBound === "1") {
        return;
      }
      container.dataset.quillClickBound = "1";
      container.addEventListener("mousedown", (event) => {
        if (event.button !== 0) {
          return;
        }
        if (event.target === editorEl || editorEl.contains(event.target)) {
          return;
        }
        // 链接浮层在编辑器容器内、正文外，不能把点击当成空白处而清掉选区
        if (event.target.closest && event.target.closest(".ql-tooltip")) {
          return;
        }
        event.preventDefault();
        quill.focus();
        const index = Math.max(0, quill.getLength() - 1);
        quill.setSelection(index, 0, "user");
      });
    },
    onEditorChange({ html }) {
      // 写入链接期间不把正文同步成空字符串，否则 :content 变空后会把编辑器清掉
      if (this.applyingLink) {
        return;
      }
      this.content = html;
      this.fieldErrors.content = false;
    },
    /** 去掉标签后的正文，用来判断编辑器是不是被清空 */
    plainQuillText(html) {
      return String(html || "")
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/gi, " ")
        .trim();
    },
    /**
     * 拦截 vue-quill-editor 在内容变化时把编辑器 innerHTML / setText 写成空。
     * 添加链接时这个回写会把已有正文清掉。
     */
    guardQuillContent(quill) {
      if (quill.contentGuardBound) {
        return;
      }
      quill.contentGuardBound = true;
      const rawSetText = quill.setText.bind(quill);
      quill.setText = (text, source) => {
        const current = quill.getText().replace(/\n/g, "").trim();
        if (current && !String(text || "").trim()) {
          return;
        }
        return rawSetText(text, source);
      };
      const desc = Object.getOwnPropertyDescriptor(Element.prototype, "innerHTML");
      const root = quill.root;
      Object.defineProperty(root, "innerHTML", {
        configurable: true,
        get() {
          return desc.get.call(this);
        },
        set(value) {
          const currentText = desc
            .get.call(this)
            .replace(/<[^>]*>/g, "")
            .replace(/&nbsp;/gi, " ")
            .trim();
          const nextText = String(value || "")
            .replace(/<[^>]*>/g, "")
            .replace(/&nbsp;/gi, " ")
            .trim();
          if (currentText && !nextText) {
            return;
          }
          desc.set.call(this, value);
        },
      });
    },
    /** 选中文字后弹出链接输入，不用 Quill 自带浮层，避免保存时清掉正文 */
    handleQuillLink(value) {
      const quill = this.getQuill();
      if (!quill) {
        return;
      }
      if (!value) {
        quill.format("link", false, "user");
        return;
      }
      const live = quill.getSelection();
      const saved = quill.selection && quill.selection.savedRange;
      const range = live && live.length ? live : saved;
      if (!range || !range.length) {
        this.$message.warning(this.$t("page.LINK_SELECT_TEXT"));
        return;
      }
      this.pendingLinkRange = { index: range.index, length: range.length };
      this.linkSnapshot = quill.getContents();
      this.linkUrl = "";
      this.linkDialog = true;
    },
    /** 把链接写回打开弹窗前选中的文字 */
    confirmQuillLink() {
      const quill = this.getQuill();
      const range = this.pendingLinkRange;
      const url = this.normalizeQuillLink(this.linkUrl);
      if (!quill || !range) {
        this.linkDialog = false;
        return;
      }
      if (!url) {
        this.$message.warning(this.$t("page.ENTER_LINK_URL"));
        return;
      }
      this.applyingLink = true;
      quill.formatText(range.index, range.length, "link", url, "user");
      if (!this.plainQuillText(quill.root.innerHTML) && this.linkSnapshot) {
        quill.setContents(this.linkSnapshot, "silent");
        quill.formatText(range.index, range.length, "link", url, "silent");
      }
      this.content = quill.root.innerHTML;
      this.fieldErrors.content = false;
      this.applyingLink = false;
      this.linkDialog = false;
    },
    /** 补全协议，保证 Quill 能保留可跳转的 href */
    normalizeQuillLink(value) {
      const url = String(value || "").trim();
      if (!url) {
        return "";
      }
      if (/^(https?:|mailto:|tel:)/i.test(url)) {
        return url;
      }
      return `https://${url}`;
    },
    getQuill() {
      const editor = this.$refs.myQuillEditor;
      if (!editor) {
        return null;
      }
      return editor.__quill || editor.quill || null;
    },

    async getReleaseConfigure() {
      //获取标签和活动
      let res = await this.$global.releaseConfigure();
      res.data.tag_list.forEach((item) => {
        item.active = false;
        item.bgColor = "";
      });
      res.code == 200
        ? ((this.activityList = res.data.activityList),
          (this.tag_list = res.data.tag_list),
          (this.voteGoods = res.data.voteGoods),
          (this.rand_code = res.data.rand_code))
        : "";
    },
    /** 富文本是否无有效正文（Quill 空内容可能为 <p><br></p>） */
    isDiscussionContentEmpty() {
      if (!this.content) {
        return true;
      }
      const text = String(this.content)
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/gi, " ")
        .trim();
      return !text;
    },
    /** 已选标签名列表 */
    getSelectedTagNames() {
      const tag = [];
      this.tag_list.forEach((item) => {
        if (item.active === true) {
          tag.push(item.tag_name);
        }
      });
      return tag;
    },
    clearReleaseFieldErrors() {
      this.fieldErrors.title = false;
      this.fieldErrors.content = false;
      this.fieldErrors.cover = false;
      this.fieldErrors.tag = false;
    },
    /** 校验发帖必填项：标红所有空字段，提示并滚动到第一个 */
    validateReleaseFields() {
      this.clearReleaseFieldErrors();
      const tag = this.getSelectedTagNames();
      const checks = [
        {
          key: "title",
          invalid: !String(this.postTitle).trim(),
          messageKey: "page.ENTER_TITLE",
          ref: "fieldTitle",
        },
        {
          key: "content",
          invalid: this.isDiscussionContentEmpty(),
          messageKey: "page.PLEASE_ENTER_CONTENT",
          ref: "fieldContent",
        },
        {
          key: "cover",
          invalid: !this.serverResultUrl,
          messageKey: "page.PLEASE_UPLOAD_COVER",
          ref: "fieldCover",
        },
        {
          key: "tag",
          invalid: tag.length === 0,
          messageKey: "page.PLEASE_SELECT_A",
          ref: "fieldTags",
        },
      ];
      let firstRef = "";
      let firstMessageKey = "";
      checks.forEach((item) => {
        if (item.invalid) {
          this.fieldErrors[item.key] = true;
          if (!firstRef) {
            firstRef = item.ref;
            firstMessageKey = item.messageKey;
          }
        }
      });
      if (!firstRef) {
        return true;
      }
      this.$message.warning(this.$t(firstMessageKey));
      this.$nextTick(() => {
        this.scrollToReleaseField(firstRef);
      });
      return false;
    },
    scrollToReleaseField(refName) {
      const target = this.$refs[refName];
      const node = target && (target.$el || target);
      if (node && typeof node.scrollIntoView === "function") {
        node.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },
    checkTag(index) {
      //tag点击事件
      this.fieldErrors.tag = false;
      if (!this.tag_list[index].active) {
        let sum = 0;
        this.tag_list.forEach((item) => {
          item.active == true ? (sum += 1) : "";
        });
        if (sum < 6) {
          this.tag_list[index].active = true;
          //设置动态颜色
          let colorArr = ["#F9874F"];
          let idx = parseInt(Math.random() * 1);
          this.tag_list[index].bgColor = colorArr[idx];
        }
      } else {
        this.tag_list[index].active = false;
      }
    },

    async aliOssConfig() {
      //获取oss配置
      let res = await this.$global.multiplefile_token();
      res.code == 200 ? (this.ossConfig = res.data) : {};
    },
    beforeAvatarUpload(file, type) {
      //格式校验
      //type==1 是上传图片 type==2 是上传视频  type3是上传封面
      if (type == 1 || type == 3) {
        //上传图片之前的验证 格式必须是 'png', 'jpg', 'jpeg', 'gif', 'bmp', 'HEIC' 大小不超过5MB
        let index = file.name.lastIndexOf(".");
        let extn = file.name.substr(index + 1);
        let isFormat =
          ["png", "jpg", "jpeg", "gif", "bmp", "HEIC"].indexOf(extn.toLowerCase()) != -1;
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isFormat) {
          this.$message.error(this.$t('page.UPLOAD_IMAGE_FORMAT_ERROR'));
        }
        if (!isLt5M) {
          this.$message.error(this.$t('page.UPLOAD_IMAGE_SIZE_5MB'));
        }
        if (isFormat && isLt5M) {
          this.uploading = true;
          type == 1 ? this.aliOssUpload(file, type) : "";
          return true;
        } else {
          this.fileList = [];
          return false;
        }
      }
      if (type == 2) {
        //上传视频之前的验证 格式必须是 "avi", "flv", "mp4", "3gp", "wmv", "rmvb", "mpeg", "mov" 大小不超过100MB
        let index = file.name.lastIndexOf(".");
        let extn = file.name.substr(index + 1);
        let isVideoFormat = ["mp4", "ogg", "webm"].indexOf(extn.toLowerCase()) != -1;
        const isLt100M = file.size / 1024 / 1024 < 100;
        if (!isVideoFormat) {
          this.$message.error(this.$t('page.UPLOAD_VIDEO_FORMAT_ERROR'));
        }
        if (!isLt100M) {
          this.$message.error(this.$t('page.UPLOAD_VIDEO_SIZE_100MB'));
        }
        if (isVideoFormat && isLt100M) {
          this.uploading = true;
          this.aliOssUpload(file, type);
          return true;
        } else {
          this.fileList = [];
          return false;
        }
      }
    },
    beforeRelease() {
      //发布作品
      this.release();
    },
    triggerMethod() {
      this.release();
    },
    /**
     * 编辑走 /posts/edit，新建仍走 /posts/add_placard。
     * 编辑请求的 id 为整数。
     */
    requestPost(discussionContent) {
      if (!this.editId) {
        return this.$global.add_placard(discussionContent);
      }
      return this.$global.postsEdit(discussionContent);
    },
    async release() {
      //发布或保存帖子

      if (!this.validateReleaseFields()) {
        return;
      }
      const tag = this.getSelectedTagNames();
      this.allImagePath.push(this.serverResultUrl);
      //投票内容

      let vote_list = {
        end_time: this.endTime / 1000,
        method_type: this.methodType,
        posts_title: this.postsTitle,
        vote_value: this.voteOptions,
      };

      this.appoint_uid.forEach((item, index) => {
        //遍历判断内容中是否还有@用户内容
        if (!this.content.includes(item.nickname)) {
          this.appoint_uid.splice(index, 1);
        }
      });
      const contentVideo =
        this.video && this.video.realityUrl ? this.video.realityUrl : this.editContentVideo || "";
      const postType = contentVideo ? 2 : this.editType || 1;
      let discussionContent = {
        imagePath: this.editId ? this.buildEditImagePath() : this.allImagePath.join(),
        tag: tag.join(),
        title: this.postTitle,
        coverImagePath: this.serverResultUrl,
        thumb_video: this.editId
          ? postType === 2
            ? this.serverResultUrl || this.editThumbVideo
            : this.editThumbVideo || ""
          : this.serverResultUrl,
        content: this.content,
        latitude_longitude: "",
        ll_name: "",
        id: this.editId ? Number(this.editId) : "",
        appoint_uid:
          this.editId && !this.appoint_uid.length
            ? this.editAppointUid || ""
            : JSON.stringify(this.appoint_uid),
        type: this.editId ? String(postType) : this.video != "" ? 2 : 1,
        goods_id: this.editId
          ? this.productValue == null || this.productValue === ""
            ? ""
            : String(this.productValue)
          : this.productValue,
        vote_list: this.voteContent ? vote_list : {},
        activityId: this.editId
          ? this.lockedActivityId
            ? String(this.lockedActivityId)
            : ""
          : "7",
        video_time:
          this.editId && contentVideo === this.editContentVideo ? this.editVideoTime || "" : "",
        content_video: contentVideo,
        rand_code: this.rand_code,
        check_str: this.captchaCode,
      };
      if (!this.editId) {
        discussionContent.class_id = "1";
        discussionContent.privacy = "1";
      }

      this.submitLoading = true;
      let res = await this.requestPost(discussionContent);

      const SUCCESS = "success";

      if (res.code === 200) {
        this.$message({
          message: res.msg,
          type: SUCCESS,
        });
        this.$refs.verification.changeVisible(false);
        this.$refs.verification.captchaCode = "";

        const postsId = (res.data && res.data.posts_id) || this.editId;
        // 编辑不再打首次发帖埋点，避免重复触发发帖积分和任务
        if (!this.editId) {
          this.$track("post_created", {
            content_id: postsId,
            content_title: this.postTitle,
            content_tag: tag.join(),
            is_poll_used: this.voteContent ? "1" : "0",
            item_name:
              this.voteGoods.find((item) => item.id == this.productValue)?.title || "",
            item_link:
              this.voteGoods.find((item) => item.id == this.productValue)?.buy_url || "",
            item_linkid: this.productValue,
          });
        }
        setTimeout(() => {
          this.$router.push({
            path: `/discussion/${postsId}`,
          });
        }, 1000);
      } else if (res.code == 509) {
        this.submitLoading = false;
        this.$refs.verification.changeVisible(true);
        this.$refs.verification.getCaptcha();
      } else {
        this.$refs.verification.getCaptcha();
        this.$refs.verification.captchaCode = "";
        this.$message.error(this.$t('page.PLEASE_TRY_AGAIN'));
      }
      this.captchaCode = "";
    },
    async aliOssUpload(file, type) {
        try {
        // 获取OSS配置
        this.loading = true
        await this.aliOssConfig();
        const result = await this.$ossUpload(file.raw, this.ossConfig, {
            progress: (p, cpt, res) => {
            console.log(parseInt(p * 100));
            this.schedule = this.$t('page.UPLOAD_PROGRESS', { n: parseInt(p * 100) });
          },
        });
        console.log(result);
        // console.log('https://media.xp-pen.com' + result.name);//https://media.xp-pen.com
        this.vedioTips = false;
        this.fileList = []; //清空文件列表
        setTimeout(() => {
          this.uploading = false;
          this.percentage = 0;
        }, 500);
        const resultReal = await this.$global.ossUrlFind({
          oss_url: `https://xfanstemp.oss-us-west-1.aliyuncs.com${result.name}`,
        });
        const log = await this.$global.uploadLog({
          url: resultReal.data,
          log_type: 2,
          rand_code: this.rand_code,
        });
        if (type == 1) {
          let quill = this.$refs.myQuillEditor.__quill; // 获取富文本编辑器
          let index = quill.selection.savedRange.index; // 获取光标位置
          this.$refs.myQuillEditor.__quill.insertEmbed(index, "image", resultReal.data);
          quill.setSelection(index + 1); // 光标移到插入内容后面
          this.allImagePath.push(resultReal.data);
          this.loading = false;
          this.schedule = "";
        } else {
          resultReal.code == 200
            ? (this.video = {
                realityUrl: resultReal.data,
                virtualUrl: URL.createObjectURL(file.raw),
              })
            : "";
          this.content += `<iframe frameborder="0"  src="${this.video.realityUrl}" allowfullscreen></iframe></br>`;
          this.loading = false;
        }


      } catch(err) {
        console.error('Upload failed:', err);
        this.uploadloading = false;
        this.$message.error(this.$t('page.UPLOAD_FAILED'));
      }

    },

    initiate() {
      //添加投票
      if (this.postsTitle == "") {
        this.$message(this.$t('page.ENTER_POLL_TITLE'));
        return false;
      }
      if (
        !this.voteOptions.every((item) => {
          return item.name_type != "";
        })
      ) {
        this.$message(this.$t('page.ENTER_POLL_OPTION'));
        return false;
      }
      if (this.endTime == "") {
        this.$message(this.$t('page.SELECT_POLL_END_DATE'));
        return false;
      }
      this.voteDialog = false;
      this.voteContent = true;
    },
    dialogSize() {
      //模态框尺寸
      document.body.clientWidth <= 768
        ? (this.voteDialogWidth = "90%")
        : document.body.clientWidth >= 768 && document.body.clientWidth <= 1660
        ? (this.voteDialogWidth = "35%")
        : (this.voteDialogWidth = "25%");
      window.onresize = () => {
        document.body.clientWidth <= 768
          ? (this.voteDialogWidth = "90%")
          : document.body.clientWidth >= 768 && document.body.clientWidth <= 1660
          ? (this.voteDialogWidth = "35%")
          : (this.voteDialogWidth = "25%");
      };
    },
    /**
     * 让 Quill 在重绘链接时保留 /user/{uid} 上的 data-uid。
     * 个人主页链接不打开新窗口。
     */
    registerAtUserLink() {
      if (!process.client) {
        return;
      }
      const Quill = require("quill");
      if (Quill.__atUserLinkReady) {
        return;
      }
      const Link = Quill.import("formats/link");
      /** 从 /user/280508 取出用户 id */
      const userIdFromHref = (href) => {
        if (typeof href !== "string") {
          return "";
        }
        const matched = href.match(/^\/user\/(\d+)\/?$/);
        return matched ? matched[1] : "";
      };
      class UserLink extends Link {
        static create(value) {
          const node = super.create(value);
          const uid = userIdFromHref(value);
          if (uid) {
            node.setAttribute("data-uid", uid);
            node.removeAttribute("target");
            node.removeAttribute("rel");
          }
          return node;
        }

        format(name, value) {
          super.format(name, value);
          if (name !== this.statics.blotName) {
            return;
          }
          const uid = userIdFromHref(this.domNode.getAttribute("href"));
          if (uid) {
            this.domNode.setAttribute("data-uid", uid);
            this.domNode.removeAttribute("target");
            this.domNode.removeAttribute("rel");
          } else {
            this.domNode.removeAttribute("data-uid");
          }
        }
      }
      Quill.register(UserLink, true);
      Quill.__atUserLinkReady = true;
    },
    /**
     * 把旧的 App @ 脚本链接换成主页链接。
     * @param {string} html 正文 HTML
     * @returns {string}
     */
    normalizeAtMentions(html) {
      if (!html || html.indexOf("atUser") === -1) {
        return html || "";
      }
      return html.replace(
        /<a\b[^>]*\batUser(?:\.postMessage)?\((\d+)\)[^>]*>/gi,
        (_, uid) => `<a href="/user/${uid}" data-uid="${uid}">`
      );
    },
    appendAt(item) {
      // 正文里的 @ 用户写成可跳转的主页链接
      const uid = item && item.uid != null ? String(item.uid).trim() : "";
      if (!uid) {
        return;
      }
      this.content += `<a href="/user/${uid}" data-uid="${uid}">@${item.nickname}</a>`;
      this.appoint_uid.push({ nickname: item.nickname, uid: item.uid });
      this.atDialogVisible = false;
    },
    preview() {
      //预览
      let self = this;
      let tag = [];
      this.tag_list.forEach((item) => {
        item.active == true ? tag.push(item.tag_name) : "";
      });
      let previewData = {
        tag: tag.join(","),
        title: this.postTitle,
        content: this.content,
        type: 3,
        goods: this.voteGoods.find(function (item) {
          if (item.id == self.productValue) {
            return item;
          }
        }),
        face_url: this.$store.state.userInfo.face_url,
        nickname: this.$store.state.userInfo.userInfo.nickname,
      };
      localStorage.setItem("previewWord", JSON.stringify(previewData));
      let routeData = this.$router.resolve({ path: "/preview/work" });
      window.open(routeData.href, "_blank");
    },
    async uploadSectionFile(param) {
      console.log(param);
      let { file } = param;
      try {
        // 获取OSS配置
        await this.aliOssConfig();
        const resultOss = await this.$ossUpload(file, this.ossConfig, {
            progress: (p, cpt, res) => {
            param.onProgress({ percent: parseInt(p * 100) });
          },
        });
        console.log(resultOss);
        param.onSuccess(resultOss);
        //防止重复命名
        const result = await this.$global.ossUrlFind({
          oss_url: `https://xfanstemp.oss-us-west-1.aliyuncs.com${resultOss.name}`,
        });
        this.imageUrl = URL.createObjectURL(file);
        this.serverResultUrl = result.data;
        this.fieldErrors.cover = false;
        const log = await this.$global.uploadLog({
          url: result.data,
          log_type: 1,
          rand_code: this.rand_code,
        });


      } catch(err) {
        console.error('Upload failed:', err);
        this.uploadloading = false;
        this.$message.error(this.$t('page.UPLOAD_FAILED'));
      }


    },
    uploadPollCover(index) {
      this.voteImgIndex = index;
      document.querySelector(".uploadCover input").click();
    },
    async uploadVoteCover(param) {
      let { file } = param;
      let index = file.name.lastIndexOf(".");
      let extn = file.name.substr(index + 1);
      let isFormat =
        ["png", "jpg", "jpeg", "gif", "bmp", "HEIC"].indexOf(extn.toLowerCase()) != -1;
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isFormat) {
        this.$message.error(this.$t('page.UPLOAD_IMAGE_FORMAT_ERROR'));
      }
      if (!isLt5M) {
        this.$message.error(this.$t('page.UPLOAD_IMAGE_SIZE_5MB'));
      }
      if (isFormat && isLt5M) {
        let { file } = param;
        try {
          // 获取OSS配置
          await this.aliOssConfig();
          const resultOss = await this.$ossUpload(file, this.ossConfig, {
            progress: (p, cpt, res) => {
              param.onProgress({ percent: parseInt(p * 100) });
            },
          });
          param.onSuccess(resultOss);
          //防止重复命名
          const result = await this.$global.ossUrlFind({
            oss_url: `https://xfanstemp.oss-us-west-1.aliyuncs.com${resultOss.name}`,
          });
          console.log(result);
          let obj = {
            vote_img: result.data,
            name_type: this.voteOptions[this.voteImgIndex].name_type,
          };
          this.$set(this.voteOptions, this.voteImgIndex, obj);

          const log = await this.$global.uploadLog({
            url: result.data,
            log_type: 5,
            rand_code: this.rand_code,
          });
        } catch (err) {
          console.error("Upload failed:", err);
          this.uploadloading = false;
          this.$message.error(this.$t('page.UPLOAD_FAILED'));
        }
      } else {
        return false;
      }
    },
  },
};
